import { render } from "./MainSearchApp.vue?vue&type=template&id=a7ac47b6"
import script from "./MainSearchApp.vue?vue&type=script&lang=js"
export * from "./MainSearchApp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/trevorwagner/Sites/Starkey/wp-content/themes/starkey-realty/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__